export const environment = {
    production: true,
    API_URL: 'https://admin.paco.app/api',
    //API_URL: 'https://sandbox.paco.app/api',
    //API_URL: 'http://localhost:8000/api',
    ONE_SIGNAL_APP_ID: '40a62927-fbe6-4554-9c3c-b5c8387fbbb4',
    FIREBASE_SENDER_ID: 'FIREBASE_SENDER_ID',
    MAPSKEY: 'pk.eyJ1IjoiamN2aXpjYWlubyIsImEiOiJja2E4Zml1NHowZTkzMnJwaWdiMHlsMjZtIn0.6ciM4BUEDiwrrJi6xqlnPg',
    SMARTLOOK_KEY: '4a0168938f55324aa5d5d67e7ad826f6066894f7',
    HELP_URL:'https://pepeferia.paco.app/portal/es/kb/pepe-feria',
    API_KEY_ZOHO_ANDROID:'NDX2fFtcVzv5080DD9WowTOjHiGnO%2F7JcYwpZ9xJ1q1yH%2Bo%2FPyTfUgM7KtEoGSjH',
    API_KEY_ZOHO_IOS:"NDX2fFtcVzv5080DD9WowTOjHiGnO%2F7JcYwpZ9xJ1q1yH%2Bo%2FPyTfUgM7KtEoGSjH",
    ACCESS_TOKEN_ZOHO_ANDROID:'harFESiTd13HyjwsradLM9T%2BGiTPiRmEMer1s3eFLryY1eqqzg981heOCOF01khcHpvhoXbII8G0btZxQQ6B0H7KYD2f06BMj9Cr%2FMDjQbi6HkQeHOdSew%3D%3D',
    ACCESS_TOKEN_ZOHO_IOS:'h9HFrUws9ukF2fSR639CZUmiBtU1ZSfE6B%2BQnZVKwECUontSI9u27SnyGYz9shUquqlACwLvR42CRM6DtlKIV%2BGq6JMzdBVm5xsfHoS1w%2B4%3D',
    XML_BASE_URL:'https://admin.paco.app',
    BUGSNAG_API_KEY:'8bbb698c6e080ffebf89835df2d45f31',
    APP_ID_IOS:'6752444020',
    APP_GENERAL_NAME:'CDMX'
};
